<script context="module">
  import AppLayout from '$lib/layouts/AppLayout.svelte'
  export const layout = AppLayout
</script>

<script lang="ts">
  import { router } from "@inertiajs/svelte";
  import { Plus, FileText, Globe, Edit3, Trash2, ExternalLink } from "lucide-svelte";
  import { toast } from "svelte-sonner";

  let { pages = [], site_info } = $props();

  function deletePage(id: string) {
    if (!confirm("确定要删除这个页面吗？关联的翻译也将被清除。")) return;
    router.delete(`/pages/${id}`, {
      onSuccess: () => toast.success("页面已删除")
    });
  }
</script>

<div class="p-8 max-w-7xl mx-auto">
  <div class="flex justify-between items-end mb-8">
    <div>
      <h1 class="text-3xl font-bold tracking-tight">页面管理</h1>
      <p class="text-muted-foreground mt-1">正在管理站点：<span class="font-medium text-primary">{site_info.name}</span></p>
    </div>

    <button 
      onclick={() => router.get('/pages/new')}
      class="flex items-center gap-2 px-5 py-2.5 bg-zinc-900 text-white rounded-xl hover:opacity-90 transition-all font-bold shadow-sm"
    >
      <Plus class="size-4" />
      新建页面
    </button>
  </div>

  <div class="bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-2xl overflow-hidden shadow-sm">
    <table class="w-full text-left border-collapse">
      <thead>
        <tr class="border-b bg-zinc-50/50 dark:bg-zinc-800/50">
          <th class="p-4 text-xs font-bold uppercase text-zinc-500 tracking-wider">标题 / 路径</th>
          <th class="p-4 text-xs font-bold uppercase text-zinc-500 tracking-wider">语言</th>
          <th class="p-4 text-xs font-bold uppercase text-zinc-500 tracking-wider">模式</th>
          <th class="p-4 text-xs font-bold uppercase text-zinc-500 tracking-wider">最后更新</th>
          <th class="p-4 text-xs font-bold uppercase text-zinc-500 tracking-wider text-right">操作</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-zinc-100 dark:divide-zinc-800">
        {#each pages as page}
          <tr class="hover:bg-zinc-50/50 dark:hover:bg-zinc-800/30 transition-colors group">
            <td class="p-4">
              <div class="flex items-center gap-3">
                <div class="p-2 bg-zinc-100 dark:bg-zinc-800 rounded-lg text-zinc-400 group-hover:text-primary transition-colors">
                  <FileText class="size-4" />
                </div>
                <div>
                  <div class="font-bold text-sm text-zinc-900 dark:text-zinc-100">{page.title}</div>
                  <div class="text-xs text-zinc-400 font-mono">/{page.slug}</div>
                </div>
              </div>
            </td>
            <td class="p-4">
              <span class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-zinc-100 dark:bg-zinc-800 text-[10px] font-bold uppercase text-zinc-500">
                <Globe class="size-3" />
                {page.locale}
              </span>
            </td>
            <td class="p-4">
               <span class="text-xs font-medium px-2 py-1 rounded-full border border-zinc-200 dark:border-zinc-700">
                {page.mode === 'components' ? '🧱 组件模式' : '📜 代码模式'}
              </span>
            </td>
            <td class="p-4 text-xs text-zinc-400 font-medium">
              {page.updated_at}
            </td>
            <td class="p-4 text-right">
              <div class="flex justify-end gap-2">
                <button 
                  onclick={() => router.get(`/pages/${page.id}/edit`)}
                  class="p-2 hover:bg-zinc-100 dark:hover:bg-zinc-800 rounded-lg text-zinc-600 transition-colors"
                  title="编辑内容"
                >
                  <Edit3 class="size-4" />
                </button>
                <button 
                  onclick={() => deletePage(page.id)}
                  class="p-2 hover:bg-red-50 dark:hover:bg-red-950/30 rounded-lg text-zinc-400 hover:text-red-500 transition-colors"
                  title="删除"
                >
                  <Trash2 class="size-4" />
                </button>
              </div>
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>